module.exports = __webpack_public_path__ + "img/canteen_register.f75531ea.jpg";